import type { SupportedLocale } from '@erp/shared';
export const actionNeedTranslations = {
  de: {
    title: 'Handlungsbedarf',
    refresh: 'Jetzt prüfen',
    category: 'Kategorie',
    allCategories: 'Alle Kategorien',
    urgency: 'Dringlichkeit',
    allUrgencies: 'Alle Dringlichkeiten',
    state: 'Problemzustand',
    mine: 'Meine Vorgänge',
    assignee: 'Zuständigkeit',
    allAssignees: 'Alle Zuständigkeiten',
    unassigned: 'Nicht zugewiesen',
    manage: 'Bearbeitung / Wiedervorlage',
    history: 'Fehler- und Verlaufshistorie',
    until: 'Zurückstellen bis (leer: wieder anzeigen)',
    reason: 'Begründung',
    separation:
      'Bearbeitungsstatus und Problemzustand sind getrennt. Eine erledigte Aufgabe behebt den fachlichen Grund nicht.',
    failed: 'Aktualisierung fehlgeschlagen. Der angezeigte Stand kann veraltet sein.',
    stale: 'Nicht aktuell geprüft:',
    unknown: 'Noch keine zuverlässige Aussage verfügbar.',
    empty: 'Kein Handlungsbedarf für diese Auswahl.',
    count: '{{count}} Vorgänge',
    first: 'Erstmals: {{date}}',
    last: 'Zuletzt: {{date}}',
    episode: 'Auftreten Nr. {{count}}',
    resolved: 'Behoben: {{date}}',
    deferred: 'Wiedervorlage: {{date}}',
    task: 'Zugehörige Aufgabe',
    noTask: 'Keine Aufgabe verknüpft',
    selectedTask: 'Ausgewählte Aufgabe',
    taskSearch: 'Kundenaufgabe suchen',
    createTask: 'Kundenaufgabe erstellen',
    openTask: 'Aufgabe öffnen',
    start: 'Bearbeitung beginnen',
    reasonRequired: 'Bitte die Wiedervorlage begründen.',
    invalid: 'Ungültige Eingabe.',
    futureRequired: 'Die Wiedervorlage muss in der Zukunft liegen.',
    customerMismatch: 'Die Aufgabe muss zum selben Kunden gehören.',
    conflict: 'Der Vorgang wurde geändert. Schließen, neu laden und Änderungen erneut übernehmen.',
    saved: 'Bearbeitung gespeichert',
    checked: 'Geprüft: {{date}}',
    categories: {
      PORTAL_ORDER: 'Portalbestellung',
      DOCUMENT_LOCK: 'Festschreibung',
      OVERDUE_DELIVERY: 'Überfällige Lieferung',
      STOCK_SHORTAGE: 'Bestandsbedarf',
      BATCH_EXPIRY: 'Haltbarkeit',
    },
    severity: {
      WARNING: 'Warnung',
      CRITICAL: 'Kritisch',
    },
    states: {
      OPEN: 'Offener Handlungsbedarf',
      DEFERRED: 'Zurückgestellt',
      RESOLVED: 'Behoben',
      ALL: 'Alle Zustände',
    },
    dateKinds: {
      BEST_BEFORE: 'MHD',
      EXPIRY: 'Verbrauchs-/Ablaufdatum',
      NONE: 'Fehlendes Datum',
    },
    actions: {
      PORTAL_ORDER: 'Portalvorgang klären',
      DOCUMENT_LOCK: 'Festschreibung prüfen',
      OVERDUE_DELIVERY: 'Lieferung bearbeiten',
      STOCK_SHORTAGE: 'Auftrag und Bestand prüfen',
      BATCH_EXPIRY: 'Charge prüfen',
    },
    reasons: {
      portal: 'Portalbestellung fehlgeschlagen: {{code}}.',
      delivery: 'Lieferung für {{customer}} war am {{date}} geplant und ist noch offen.',
      stock:
        'Für die geplante Lieferung am {{date}} fehlen {{quantity}} {{unit}} verfügbare Menge.',
      stockCombined:
        'Für {{orders}} geplante Aufträge fehlen insgesamt {{quantity}} {{unit}} freier Bestand.',
      expiry:
        '{{dateKind}} in {{days}} Tagen; Restbestand {{quantity}} {{unit}}. Negative Tage bedeuten überschrittene Haltbarkeit.',
      missingExpiry:
        'Haltbarkeitsdatum fehlt; Restbestand {{quantity}} {{unit}} kann nicht zuverlässig beurteilt werden.',
    },
    events: {
      OPENED: 'Erstmals erkannt',
      OBSERVED: 'Erneut festgestellt',
      REOPENED: 'Erneut aufgetreten',
      RESOLVED: 'Anhand der Quelldaten behoben',
      TASK_LINKED: 'Aufgabenverknüpfung geändert',
      DEFERRED: 'Wiedervorlage geändert',
      UPDATED: 'Geändert',
      FAILED: 'Versuch fehlgeschlagen',
      SUCCEEDED: 'Versuch erfolgreich',
      ACTION_FAILED: 'Portalaktion fehlgeschlagen',
      ERROR_DISPLAYED: 'Fehler im Portal angezeigt',
      ORDER_SUBMITTED: 'Portalbestellung übernommen',
    },
  },
  en: {
    title: 'Action needed',
    refresh: 'Check now',
    category: 'Category',
    allCategories: 'All categories',
    urgency: 'Urgency',
    allUrgencies: 'All urgency levels',
    state: 'Problem state',
    mine: 'My items',
    assignee: 'Assignee',
    allAssignees: 'All assignees',
    unassigned: 'Unassigned',
    manage: 'Handling / follow-up',
    history: 'Error and event history',
    until: 'Defer until (empty: show again)',
    reason: 'Reason',
    separation:
      'Handling and problem state are separate. Completing a task does not fix the underlying business issue.',
    failed: 'Refresh failed. The displayed information may be outdated.',
    stale: 'Not currently verified:',
    unknown: 'No reliable assessment is available yet.',
    empty: 'No action needed for this selection.',
    count: '{{count}} items',
    first: 'First: {{date}}',
    last: 'Latest: {{date}}',
    episode: 'Occurrence no. {{count}}',
    resolved: 'Resolved: {{date}}',
    deferred: 'Follow-up: {{date}}',
    task: 'Linked task',
    noTask: 'No linked task',
    selectedTask: 'Selected task',
    taskSearch: 'Find customer task',
    createTask: 'Create customer task',
    openTask: 'Open task',
    start: 'Start handling',
    reasonRequired: 'Please give a reason for deferring.',
    invalid: 'Invalid input.',
    futureRequired: 'The follow-up must be in the future.',
    customerMismatch: 'The task must belong to the same customer.',
    conflict: 'The item changed. Close, reload and apply your changes again.',
    saved: 'Handling saved',
    checked: 'Checked: {{date}}',
    categories: {
      PORTAL_ORDER: 'Portal order',
      DOCUMENT_LOCK: 'Posting',
      OVERDUE_DELIVERY: 'Overdue delivery',
      STOCK_SHORTAGE: 'Stock shortage',
      BATCH_EXPIRY: 'Shelf life',
    },
    severity: {
      WARNING: 'Warning',
      CRITICAL: 'Critical',
    },
    states: {
      OPEN: 'Open issues',
      DEFERRED: 'Deferred',
      RESOLVED: 'Resolved',
      ALL: 'All states',
    },
    dateKinds: {
      BEST_BEFORE: 'Best-before date',
      EXPIRY: 'Use-by/expiry date',
      NONE: 'Missing date',
    },
    actions: {
      PORTAL_ORDER: 'Review portal issue',
      DOCUMENT_LOCK: 'Review posting',
      OVERDUE_DELIVERY: 'Handle delivery',
      STOCK_SHORTAGE: 'Review order and stock',
      BATCH_EXPIRY: 'Review batch',
    },
    reasons: {
      portal: 'Portal order failed: {{code}}.',
      delivery: 'Delivery for {{customer}} was scheduled for {{date}} and remains open.',
      stock: 'The delivery planned for {{date}} is short of {{quantity}} {{unit}} available stock.',
      stockCombined:
        '{{orders}} scheduled orders have a combined free-stock shortage of {{quantity}} {{unit}}.',
      expiry:
        '{{dateKind}} in {{days}} days; remaining stock {{quantity}} {{unit}}. Negative days mean expired shelf life.',
      missingExpiry:
        'Shelf-life date missing; remaining stock of {{quantity}} {{unit}} cannot be reliably assessed.',
    },
    events: {
      OPENED: 'First detected',
      OBSERVED: 'Observed again',
      REOPENED: 'Reoccurred',
      RESOLVED: 'Resolved from source data',
      TASK_LINKED: 'Task link changed',
      DEFERRED: 'Follow-up changed',
      UPDATED: 'Updated',
      FAILED: 'Attempt failed',
      SUCCEEDED: 'Attempt succeeded',
      ACTION_FAILED: 'Portal action failed',
      ERROR_DISPLAYED: 'Error displayed in portal',
      ORDER_SUBMITTED: 'Portal order accepted',
    },
  },
  fr: {
    title: 'Actions requises',
    refresh: 'Vérifier maintenant',
    category: 'Catégorie',
    allCategories: 'Toutes les catégories',
    urgency: 'Urgence',
    allUrgencies: 'Tous les niveaux',
    state: 'État du problème',
    mine: 'Mes dossiers',
    assignee: 'Responsable',
    allAssignees: 'Tous les responsables',
    unassigned: 'Non attribué',
    manage: 'Traitement / rappel',
    history: 'Historique des erreurs et événements',
    until: 'Reporter jusqu’au (vide : réafficher)',
    reason: 'Motif',
    separation:
      'Le traitement et l’état du problème sont distincts. Terminer une tâche ne résout pas la cause métier.',
    failed: 'Échec de l’actualisation. Les informations affichées peuvent être obsolètes.',
    stale: 'Non vérifié actuellement :',
    unknown: 'Aucune évaluation fiable disponible pour le moment.',
    empty: 'Aucune action requise pour cette sélection.',
    count: '{{count}} dossiers',
    first: 'Première fois : {{date}}',
    last: 'Dernière fois : {{date}}',
    episode: 'Occurrence n° {{count}}',
    resolved: 'Résolu : {{date}}',
    deferred: 'Rappel : {{date}}',
    task: 'Tâche associée',
    noTask: 'Aucune tâche associée',
    selectedTask: 'Tâche sélectionnée',
    taskSearch: 'Rechercher une tâche client',
    createTask: 'Créer une tâche client',
    openTask: 'Ouvrir la tâche',
    start: 'Commencer le traitement',
    reasonRequired: 'Veuillez motiver le report.',
    invalid: 'Saisie non valide.',
    futureRequired: 'Le rappel doit être dans le futur.',
    customerMismatch: 'La tâche doit concerner le même client.',
    conflict: 'Le dossier a changé. Fermez, rechargez et réappliquez vos modifications.',
    saved: 'Traitement enregistré',
    checked: 'Vérifié : {{date}}',
    categories: {
      PORTAL_ORDER: 'Commande portail',
      DOCUMENT_LOCK: 'Validation définitive',
      OVERDUE_DELIVERY: 'Livraison en retard',
      STOCK_SHORTAGE: 'Manque de stock',
      BATCH_EXPIRY: 'Conservation',
    },
    severity: {
      WARNING: 'Avertissement',
      CRITICAL: 'Critique',
    },
    states: {
      OPEN: 'Problèmes ouverts',
      DEFERRED: 'Reportés',
      RESOLVED: 'Résolus',
      ALL: 'Tous les états',
    },
    dateKinds: {
      BEST_BEFORE: 'Date de durabilité minimale',
      EXPIRY: 'Date limite de consommation',
      NONE: 'Date absente',
    },
    actions: {
      PORTAL_ORDER: 'Examiner le portail',
      DOCUMENT_LOCK: 'Examiner la validation',
      OVERDUE_DELIVERY: 'Traiter la livraison',
      STOCK_SHORTAGE: 'Vérifier commande et stock',
      BATCH_EXPIRY: 'Vérifier le lot',
    },
    reasons: {
      portal: 'Échec de commande portail : {{code}}.',
      delivery: 'La livraison pour {{customer}} prévue le {{date}} est encore ouverte.',
      stock: 'Il manque {{quantity}} {{unit}} disponibles pour la livraison prévue le {{date}}.',
      stockCombined:
        'Il manque au total {{quantity}} {{unit}} de stock libre pour {{orders}} commandes planifiées.',
      expiry:
        '{{dateKind}} dans {{days}} jours ; stock restant {{quantity}} {{unit}}. Un nombre négatif indique une date dépassée.',
      missingExpiry:
        'Date de conservation absente ; le stock restant de {{quantity}} {{unit}} ne peut pas être évalué de manière fiable.',
    },
    events: {
      OPENED: 'Première détection',
      OBSERVED: 'Nouvelle observation',
      REOPENED: 'Réapparition',
      RESOLVED: 'Résolu selon les données source',
      TASK_LINKED: 'Lien de tâche modifié',
      DEFERRED: 'Rappel modifié',
      UPDATED: 'Modifié',
      FAILED: 'Tentative échouée',
      SUCCEEDED: 'Tentative réussie',
      ACTION_FAILED: 'Action portail échouée',
      ERROR_DISPLAYED: 'Erreur affichée dans le portail',
      ORDER_SUBMITTED: 'Commande portail acceptée',
    },
  },
  es: {
    title: 'Acciones pendientes',
    refresh: 'Comprobar ahora',
    category: 'Categoría',
    allCategories: 'Todas las categorías',
    urgency: 'Urgencia',
    allUrgencies: 'Todos los niveles',
    state: 'Estado del problema',
    mine: 'Mis casos',
    assignee: 'Responsable',
    allAssignees: 'Todos los responsables',
    unassigned: 'Sin asignar',
    manage: 'Gestión / seguimiento',
    history: 'Historial de errores y eventos',
    until: 'Posponer hasta (vacío: volver a mostrar)',
    reason: 'Motivo',
    separation:
      'La gestión y el estado del problema son distintos. Completar una tarea no resuelve la causa comercial.',
    failed: 'La actualización ha fallado. La información mostrada puede estar desactualizada.',
    stale: 'Sin verificación actual:',
    unknown: 'Aún no hay una evaluación fiable.',
    empty: 'No hay acciones pendientes para esta selección.',
    count: '{{count}} casos',
    first: 'Primera vez: {{date}}',
    last: 'Última vez: {{date}}',
    episode: 'Aparición n.º {{count}}',
    resolved: 'Resuelto: {{date}}',
    deferred: 'Seguimiento: {{date}}',
    task: 'Tarea vinculada',
    noTask: 'Sin tarea vinculada',
    selectedTask: 'Tarea seleccionada',
    taskSearch: 'Buscar tarea del cliente',
    createTask: 'Crear tarea del cliente',
    openTask: 'Abrir tarea',
    start: 'Iniciar gestión',
    reasonRequired: 'Indique el motivo del aplazamiento.',
    invalid: 'Entrada no válida.',
    futureRequired: 'El seguimiento debe ser futuro.',
    customerMismatch: 'La tarea debe pertenecer al mismo cliente.',
    conflict: 'El caso ha cambiado. Cierre, recargue y vuelva a aplicar los cambios.',
    saved: 'Gestión guardada',
    checked: 'Comprobado: {{date}}',
    categories: {
      PORTAL_ORDER: 'Pedido del portal',
      DOCUMENT_LOCK: 'Contabilización',
      OVERDUE_DELIVERY: 'Entrega vencida',
      STOCK_SHORTAGE: 'Falta de existencias',
      BATCH_EXPIRY: 'Caducidad',
    },
    severity: {
      WARNING: 'Advertencia',
      CRITICAL: 'Crítico',
    },
    states: {
      OPEN: 'Problemas abiertos',
      DEFERRED: 'Pospuestos',
      RESOLVED: 'Resueltos',
      ALL: 'Todos los estados',
    },
    dateKinds: {
      BEST_BEFORE: 'Consumo preferente',
      EXPIRY: 'Fecha de caducidad',
      NONE: 'Fecha ausente',
    },
    actions: {
      PORTAL_ORDER: 'Revisar el portal',
      DOCUMENT_LOCK: 'Revisar contabilización',
      OVERDUE_DELIVERY: 'Gestionar entrega',
      STOCK_SHORTAGE: 'Revisar pedido y stock',
      BATCH_EXPIRY: 'Revisar lote',
    },
    reasons: {
      portal: 'Pedido del portal fallido: {{code}}.',
      delivery: 'La entrega para {{customer}} prevista el {{date}} sigue abierta.',
      stock: 'Faltan {{quantity}} {{unit}} disponibles para la entrega prevista el {{date}}.',
      stockCombined:
        'Faltan en total {{quantity}} {{unit}} de stock libre para {{orders}} pedidos programados.',
      expiry:
        '{{dateKind}} en {{days}} días; existencias restantes {{quantity}} {{unit}}. Los días negativos indican una fecha superada.',
      missingExpiry:
        'Falta la fecha de conservación; no se pueden evaluar con fiabilidad las existencias de {{quantity}} {{unit}}.',
    },
    events: {
      OPENED: 'Primera detección',
      OBSERVED: 'Observado de nuevo',
      REOPENED: 'Reaparición',
      RESOLVED: 'Resuelto según datos de origen',
      TASK_LINKED: 'Vínculo de tarea modificado',
      DEFERRED: 'Seguimiento modificado',
      UPDATED: 'Actualizado',
      FAILED: 'Intento fallido',
      SUCCEEDED: 'Intento correcto',
      ACTION_FAILED: 'Acción del portal fallida',
      ERROR_DISPLAYED: 'Error mostrado en el portal',
      ORDER_SUBMITTED: 'Pedido del portal aceptado',
    },
  },
  tr: {
    title: 'İşlem gerekenler',
    refresh: 'Şimdi kontrol et',
    category: 'Kategori',
    allCategories: 'Tüm kategoriler',
    urgency: 'Aciliyet',
    allUrgencies: 'Tüm aciliyetler',
    state: 'Sorun durumu',
    mine: 'İşlemlerim',
    assignee: 'Sorumlu',
    allAssignees: 'Tüm sorumlular',
    unassigned: 'Atanmamış',
    manage: 'İşleme / takip',
    history: 'Hata ve olay geçmişi',
    until: 'Şu tarihe kadar ertele (boş: yeniden göster)',
    reason: 'Gerekçe',
    separation: 'İşleme ve sorun durumu ayrıdır. Görevin tamamlanması iş sorununu çözmez.',
    failed: 'Güncelleme başarısız. Gösterilen bilgiler eski olabilir.',
    stale: 'Şu anda doğrulanmadı:',
    unknown: 'Henüz güvenilir değerlendirme yok.',
    empty: 'Bu seçim için işlem gerekmiyor.',
    count: '{{count}} işlem',
    first: 'İlk: {{date}}',
    last: 'Son: {{date}}',
    episode: 'Tekrarlanma no. {{count}}',
    resolved: 'Çözüldü: {{date}}',
    deferred: 'Takip: {{date}}',
    task: 'Bağlı görev',
    noTask: 'Bağlı görev yok',
    selectedTask: 'Seçilen görev',
    taskSearch: 'Müşteri görevi ara',
    createTask: 'Müşteri görevi oluştur',
    openTask: 'Görevi aç',
    start: 'İşlemeye başla',
    reasonRequired: 'Lütfen erteleme gerekçesini girin.',
    invalid: 'Geçersiz giriş.',
    futureRequired: 'Takip tarihi gelecekte olmalıdır.',
    customerMismatch: 'Görev aynı müşteriye ait olmalıdır.',
    conflict: 'İşlem değişti. Kapatın, yeniden yükleyin ve değişiklikleri tekrar uygulayın.',
    saved: 'İşleme kaydedildi',
    checked: 'Kontrol: {{date}}',
    categories: {
      PORTAL_ORDER: 'Portal siparişi',
      DOCUMENT_LOCK: 'Kesinleştirme',
      OVERDUE_DELIVERY: 'Gecikmiş teslimat',
      STOCK_SHORTAGE: 'Stok eksikliği',
      BATCH_EXPIRY: 'Raf ömrü',
    },
    severity: {
      WARNING: 'Uyarı',
      CRITICAL: 'Kritik',
    },
    states: {
      OPEN: 'Açık sorunlar',
      DEFERRED: 'Ertelenen',
      RESOLVED: 'Çözülen',
      ALL: 'Tüm durumlar',
    },
    dateKinds: {
      BEST_BEFORE: 'Tavsiye edilen tüketim tarihi',
      EXPIRY: 'Son tüketim tarihi',
      NONE: 'Eksik tarih',
    },
    actions: {
      PORTAL_ORDER: 'Portal işlemini incele',
      DOCUMENT_LOCK: 'Kesinleştirmeyi incele',
      OVERDUE_DELIVERY: 'Teslimatı işle',
      STOCK_SHORTAGE: 'Sipariş ve stoku incele',
      BATCH_EXPIRY: 'Partiyi incele',
    },
    reasons: {
      portal: 'Portal siparişi başarısız: {{code}}.',
      delivery: '{{customer}} için {{date}} tarihinde planlanan teslimat hâlâ açık.',
      stock: '{{date}} için planlanan teslimatta {{quantity}} {{unit}} kullanılabilir stok eksik.',
      stockCombined:
        'Planlanan {{orders}} sipariş için toplam {{quantity}} {{unit}} serbest stok eksik.',
      expiry:
        '{{dateKind}} için {{days}} gün; kalan stok {{quantity}} {{unit}}. Negatif günler sürenin aşıldığını belirtir.',
      missingExpiry:
        'Raf ömrü tarihi eksik; {{quantity}} {{unit}} kalan stok güvenilir biçimde değerlendirilemiyor.',
    },
    events: {
      OPENED: 'İlk tespit',
      OBSERVED: 'Yeniden gözlendi',
      REOPENED: 'Tekrar oluştu',
      RESOLVED: 'Kaynak verilerle çözüldü',
      TASK_LINKED: 'Görev bağlantısı değişti',
      DEFERRED: 'Takip değişti',
      UPDATED: 'Güncellendi',
      FAILED: 'Deneme başarısız',
      SUCCEEDED: 'Deneme başarılı',
      ACTION_FAILED: 'Portal işlemi başarısız',
      ERROR_DISPLAYED: 'Portalda hata gösterildi',
      ORDER_SUBMITTED: 'Portal siparişi kabul edildi',
    },
  },
} as const satisfies Record<SupportedLocale, Record<string, string | Record<string, string>>>;
